import type { IconData } from '@stacksjs/iconify-core'

export const healthAmbulanceCall: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22.115 7.51v3.04h-3.05v4.58h3.05v3.04h4.57v-3.04h3.05v-4.58h-3.05V7.51zm3.05 21.33h1.52v1.52h-1.52Zm-3.05 1.52h3.05V32h-3.05Zm0-3.04h-1.52v1.52h-1.53v1.52h3.05zm-3.05-1.53h1.53v1.53h-1.53Z\"/><path fill=\"currentColor\" d=\"M17.545 27.32h1.52v1.52h-1.52Zm-3.05 3.04h4.57V32h-4.57Zm0-9.14h1.53v6.1h-1.53Zm0-18.29h1.53v6.1h-1.53Zm-1.52 25.91h-6.1v1.52h7.62v-3.04h-1.52zm0-27.43h1.52v1.52h-1.52Zm-1.53 18.29h3.05v1.52h-3.05Zm0-10.67h3.05v1.52h-3.05Zm0-6.1h-1.52v4.58h3.05V4.46h-1.53zm-1.52 24.39h1.52v-1.53h1.53v-3.05h-3.05zm0-16.77h1.52v9.15h-1.52ZM6.875 0h6.1v1.41h-6.1Zm-1.52 27.32h1.52v1.52h-1.52Zm0-25.91h1.52v1.52h-1.52Zm-1.53 22.86h1.53v3.05h-1.53Zm0-21.34h1.53v3.05h-1.53Zm-1.56 3.05h1.56v18.29h-1.56Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default healthAmbulanceCall
